import React from 'react';
import {Outlet} from 'react-router-dom'

const AoLeadsLayout = () => (

    <div className="row">
        <div className="col-xs-12">
            <Outlet/>
        </div>
    </div>
);

export default AoLeadsLayout;